import type { FunctionComponent } from 'react'
import {
  ItemBottomActions,
  PaymentMethodBottomActions,
  ShippingOptionsBottomActions,
  ShippingRateBottomActions,
} from './BottomActions'
import {
  ItemTopActions,
  PaymentMethodTopActions,
  ShippingOptionsTopActions,
  ShippingRateTopActions,
} from './TopActions'
import { OrderCheckoutActivePanelEnum } from '@ztechapps/order.common'
import { ItemActionProgressStep } from './progress/ItemActionProgressStep'
import { ShippingOptionsActionProgressStep } from './progress/ShippingOptionsActionProgressStep'
import { ShippingRateActionProgressStep } from './progress/ShippingRateActionProgressStep'
import { PaymentMethodActionProgressStep } from './progress/PaymentMethodActionProgressStep'

import type { Components } from './components'
import { ShippingOptionsPanel } from './panels/ShippingOptionsPanel'
import { NullComponent } from '@ztechapps/webui.util'
import { ShippingRatePanel } from './panels/ShippingRatePanel'

export type CheckoutStep = {
  panel: FunctionComponent
  progress: FunctionComponent
  bottomAction: FunctionComponent
  topAction: FunctionComponent
  itemKey: OrderCheckoutActivePanelEnum
}

export const getDefaultCheckoutSteps = (components?: Components): CheckoutStep[] => {
  return [
    {
      panel: components?.itemPanel ?? NullComponent,
      progress: ItemActionProgressStep,
      bottomAction: ItemBottomActions,
      topAction: ItemTopActions,
      itemKey: OrderCheckoutActivePanelEnum.item,
    },
    {
      panel: ShippingOptionsPanel,
      progress: ShippingOptionsActionProgressStep,
      bottomAction: ShippingOptionsBottomActions,
      topAction: ShippingOptionsTopActions,
      itemKey: OrderCheckoutActivePanelEnum.shippingOptions,
    },
    {
      panel: components?.shippingRatePanel ?? ShippingRatePanel,
      progress: ShippingRateActionProgressStep,
      bottomAction: ShippingRateBottomActions,
      topAction: ShippingRateTopActions,
      itemKey: OrderCheckoutActivePanelEnum.shippingRate,
    },
    {
      panel: components?.paymentMethodPanel ?? NullComponent,
      progress: PaymentMethodActionProgressStep,
      bottomAction: PaymentMethodBottomActions,
      topAction: PaymentMethodTopActions,
      itemKey: OrderCheckoutActivePanelEnum.paymentMethod,
    },
  ]
}
